const carouselData = [
  {
    title: '暑期追剧指南：2026必看片单',
    desc: '从国产口碑剧到海外热播，一文带你解锁暑期全部精彩内容。',
    img: 'https://readdy.ai/api/search-image?query=A%20curated%20collection%20of%20movie%20and%20drama%20posters%20arranged%20artistically%20on%20a%20warm%20minimal%20background%2C%20summer%20vibes%20with%20golden%20hour%20lighting%2C%20editorial%20film%20festival%20style%2C%20clean%20composition%20with%20warm%20coral%20and%20cream%20tones&width=1000&height=500&seq=carousel-summer-01&orientation=landscape',
    tag: '编辑推荐',
  },
  {
    title: '91免费 V8.2 深度体验报告',
    desc: '新版本AI推荐引擎究竟有多准？我们实测了100部影片后告诉你答案。',
    img: 'https://readdy.ai/api/search-image?query=A%20smartphone%20and%20tablet%20displaying%20a%20modern%20app%20interface%20with%20ratings%20and%20charts%2C%20placed%20on%20a%20clean%20desk%20with%20notebook%20and%20pen%2C%20warm%20ambient%20light%2C%20professional%20product%20review%20photography&width=1000&height=500&seq=carousel-review-02&orientation=landscape',
    tag: '深度评测',
  },
  {
    title: '免费看片软件安全终极指南',
    desc: '教你识别正规软件与恶意应用，保护手机安全与个人隐私。',
    img: 'https://readdy.ai/api/search-image?query=A%20shield%20icon%20and%20security%20concept%20visual%20on%20a%20clean%20digital%20screen%2C%20surrounded%20by%20app%20icons%20with%20verified%20badges%2C%20warm%20minimal%20background%2C%20modern%20cybersecurity%20aesthetic%2C%20soft%20lighting%2C%20professional%20tech%20photography&width=1000&height=500&seq=carousel-security-03&orientation=landscape',
    tag: '安全指南',
  },
  {
    title: '安卓 vs 苹果：哪个平台看片体验更好？',
    desc: '从画质、流畅度、功能丰富度全面对比两大平台看片体验差异。',
    img: 'https://readdy.ai/api/search-image?query=Android%20smartphone%20and%20iPhone%20side%20by%20side%20both%20displaying%20video%20player%20screens%20for%20comparison%2C%20clean%20white%20surface%2C%20minimal%20tech%20comparison%20setup%2C%20bright%20studio%20lighting%2C%20editorial%20photography&width=1000&height=500&seq=carousel-compare-04&orientation=landscape',
    tag: '平台对比',
  },
  {
    title: '91免费看片冷知识：10个隐藏功能',
    desc: '手势控制、画中画、倍速播放...这些你可能不知道的实用小技巧。',
    img: 'https://readdy.ai/api/search-image?query=A%20laptop%20screen%20showing%20a%20video%20player%20with%20various%20control%20icons%20and%20settings%20menu%20overlay%2C%20clean%20workspace%20with%20coffee%20and%20headphones%2C%20warm%20natural%20light%20from%20window%2C%20cozy%20home%20office%20vibe&width=1000&height=500&seq=carousel-tips-05&orientation=landscape',
    tag: '技巧合集',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">焦点专题</h2>
          <p className="mt-2 text-sm text-foreground-500">精选深度内容，发现更多精彩</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselData.slice(0, 2).map((item, i) => (
            <a
              key={i}
              href={`#carousel-${i}`}
              className="lg:col-span-1 group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="aspect-[2/1] overflow-hidden bg-background-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <span className="text-[10px] px-2 py-0.5 bg-accent-100 text-accent-800 rounded-full font-medium">{item.tag}</span>
                <h3 className="mt-2 font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                <p className="mt-1 text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}

          {carouselData.slice(2, 3).map((item, i) => (
            <a
              key={i + 2}
              href={`#carousel-${i + 2}`}
              className="md:col-span-2 lg:col-span-1 group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="aspect-[2/1] overflow-hidden bg-background-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <span className="text-[10px] px-2 py-0.5 bg-accent-100 text-accent-800 rounded-full font-medium">{item.tag}</span>
                <h3 className="mt-2 font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                <p className="mt-1 text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}

          {carouselData.slice(3).map((item, i) => (
            <a
              key={i + 3}
              href={`#carousel-${i + 3}`}
              className={`${i === 0 ? 'lg:col-span-2' : 'lg:col-span-1'} group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all cursor-pointer`}
            >
              <div className="aspect-[2/1] overflow-hidden bg-background-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <span className="text-[10px] px-2 py-0.5 bg-accent-100 text-accent-800 rounded-full font-medium">{item.tag}</span>
                <h3 className="mt-2 font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                <p className="mt-1 text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}